




























import VueOptions from '@utils/VueOptions'

settings =
  name: 'MediaCard'

  vue:
    props: ['item', 'isSelected']

    computed:
      tags: -> @item?.tags || []

export default VueOptions.vue settings
